$(document).ready(function(){
  setTimeout(function(){
$('.feature-slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 800,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0641/5207/6520/files/Vector_48.png'>","<img src='https://cdn.shopify.com/s/files/1/0641/5207/6520/files/Vector_49.png'>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 

},500)
  setTimeout(function(){
  $('#review_slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 800,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0641/5207/6520/files/Vector_48.png'>","<img src='https://cdn.shopify.com/s/files/1/0641/5207/6520/files/Vector_49.png'>"],
	     responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 
  	},1000)
});

jQuery(document).ready(function(){
  
  // Add 'active' class to the first visible tab button and its corresponding tab body
  jQuery(".tab-btn:visible").first().addClass("active");
  var firstTabDataVal = jQuery(".tab-btn:visible").first().attr("data-val");
  jQuery(".product-tab-body." + firstTabDataVal).addClass("active");

  // Handle tab button clicks
  jQuery(".tab-btn").click(function(){
    var id_tab = jQuery(this).attr("data-val");

    // Remove 'active' class from all tab buttons and add to the clicked one
    jQuery(".tab-btn").removeClass("active");
    jQuery(this).addClass("active");
    
    // Remove 'active' class from all tab bodies and add to the target one
    jQuery(".product-tab-body").removeClass("active");
    jQuery(".product-tab-body." + id_tab).addClass("active");
  });
});